import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { Dropdown } from '../ButtonWithDropdown/ButtonWithDropdown';
import { getQTipData } from '../Tooltip/qTip.utilities';
import type { TriggerWithDropdownProps } from './TriggerWithDropdown.types';

const styles = stylex.create({
  trigger: {
    borderStyle: 'none',
    backgroundColor: 'transparent',
    outlineStyle: 'none',
    padding: 0,
    font: 'inherit',
    color: 'inherit',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'transparent',
    outlineStyle: 'none',
  },
  disabled: { cursor: 'not-allowed', opacity: 0.5 },
});

const TriggerWithDropdown = ({ 'aria-busy': ariaBusy, ...rest }: TriggerWithDropdownProps) => {
  const { triggerIcon, id, extraClassNames = '', xstyle, disabled = false, ...tooltipProps } = rest;
  const tooltipData = getQTipData(tooltipProps);
  const contentProps = stylex.props(styles.content, disabled && styles.disabled, xstyle);

  return (
    <Dropdown {...rest}>
      <DropdownMenu.Trigger id={id} {...stylex.props(styles.trigger)} aria-busy={ariaBusy} disabled={disabled}>
        <div {...tooltipData} {...contentProps} className={clsx(contentProps.className, extraClassNames)}>
          {triggerIcon}
        </div>
      </DropdownMenu.Trigger>
    </Dropdown>
  );
};

export default TriggerWithDropdown;
